import { useMemo, type ReactNode } from 'react';

import {
  WidgetDisplayContext,
  type WidgetDisplayContextValue,
} from './widget-display.context';

type WidgetDisplayProviderProps = WidgetDisplayContextValue & {
  children: ReactNode;
};

export const WidgetDisplayProvider = ({
  children,
  configStore,
  mode,
}: WidgetDisplayProviderProps) => {
  const value = useMemo(() => ({ configStore, mode }), [configStore, mode]);

  return (
    <WidgetDisplayContext.Provider value={value}>
      {children}
    </WidgetDisplayContext.Provider>
  );
};
